<template>
    <tiptap-options-menu :icon="optionsIcon" :title="optionsTitle" :disabled="!hasOptions" @save="onOptionsSave">
        <template #activator="{ on, attrs }">
            <app-tooltip>
                <app-button
                    :value="name"
                    :icon="icon"
                    icon-size="1rem"
                    :class="btnClass"
                    :disabled="disabled"
                    small
                    :secondary="active"
                    v-bind="attrs"
                    v-on="on"
                    @click="onBtnClick"
                />
                <template #display>
                    {{ text }}
                    <code v-if="shortcut">{{ shortcut }}</code>
                </template>
            </app-tooltip>
        </template>

        <template v-if="hasOptions">
            <template v-if="options.type === 'link'">
                <field-url v-if="_.has(optionsArgs, 'href')" v-model="optionsArgs.href" :label="$t('url')" required />
            </template>
        </template>
    </tiptap-options-menu>
</template>

<script>
export default {
    name: 'AppWysiwygToolbarMark',
    components: {
        TiptapOptionsMenu: () =>
            import(
                /* webpackChunkName: "core" */
                '@/lib/tiptap/components/TiptapOptionsMenu.vue'
            ),
        FieldUrl: () =>
            import(
                /* webpackChunkName: "fields" */
                '@/components/fields/Url'
            )
    },
    props: {
        editor: {
            type: Object,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            required: true
        },
        text: {
            type: String,
            required: true
        },
        shortcut: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        active: {
            type: Boolean,
            default: false
        },
        options: {
            type: Object,
            default: null
        }
    },
    data: () => ({
        optionsArgs: null
    }),
    computed: {
        btnClass() {
            let classList = ['app-wysiwyg__button'];

            if (this.active) {
                classList.push('app-wysiwyg__button--active');
            }

            return classList.join(' ');
        },
        hasOptions() {
            return !this._.isNil(this.options);
        },
        optionsIcon() {
            if (this._.has(this.options, 'icon')) {
                return this.options.icon;
            }
            return this.icon;
        },
        optionsTitle() {
            if (this._.has(this.options, 'title')) {
                return this.options.title;
            }
            return this.text;
        }
    },
    methods: {
        onBtnClick() {
            if (this.disabled) {
                return;
            }
            if (!this.hasOptions) {
                return this.$emit('run');
            }

            if (this.hasOptions && this.options.type === 'link') {
                this.setLinkArgs();
            }
        },
        setLinkArgs() {
            const linkAttr = this.editor.getAttributes('link');

            if (!this._.isEmpty(linkAttr)) {
                this.optionsArgs = linkAttr;
            } else {
                this.optionsArgs = this._.clone(this.options.args);
            }
        },
        onOptionsSave() {
            this.$emit('run', this.optionsArgs);
        }
    }
};
</script>
